export default __webpack_public_path__ + "static/media/back_button.a4e073ab.svg";